// @ts-strict-ignore
import React, { Fragment } from 'react'
import { getValue } from '../../../utils/product-schema'
import { Icon } from '../../../atoms'

export const Eligibility = ({ criteria, data }) => (
  <div className='money-voice-top-picks__details'>
    {criteria.map((c, index) => {
      const value = getValue(c.value, data)
      return (
        value !== undefined &&
        value !== null && (
          <Fragment key={index}>
            <div className='money-voice-top-picks__details__name'>{c.label}</div>
            <div className='money-voice-top-picks__details__value'>
              {value === true ? (
                <Icon glyph='tick-green' size={24} />
              ) : value === false ? (
                'NO'
              ) : (
                value
              )}
            </div>
          </Fragment>
        )
      )
    })}
  </div>
)
